<template>
    <div class="all">
        <div class="clearfix">
            <div class="w400 ml20 fr">
                <div class="grid h-auto">
                    <div class="grid-header">
                        <h2 class="title">分析词</h2>
                    </div>
                    <div class="grid-body mt30">
                        <div class="ci-warp clearfix">
                            <span class="ci" v-for="(item,index) in detail.keywordsFinal" :key="index">{{item}}</span>
                        </div>
                    </div>
                </div>
                <div class="grid h-auto mt20">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">情感判断</h2>
                    </div>
                    <div class="grid-body">
                        <div class="echart-warp">
                            <!-- <halfPieChart id="halfPieChart" :dataArray="halfPieChartData" v-if="halfPieChartData != ''"></halfPieChart> -->
                            <div class="emotion mt30 clearfix" v-if="emotion === '正面'">
                                <h2 class="color-blue fl">正面</h2>
                                <span class="fr"><i class="icons front-icon"></i></span>
                            </div>
                            <div class="emotion mt30 clearfix" v-if="emotion === '负面'">
                                <h2 class="color-red fl">负面</h2>
                                <span class="fr"><i class="icons negative-icon"></i></span>
                            </div>
                            <div class="emotion mt30 clearfix" v-if="emotion === '中性'">
                                <h2 class="color-orange fl">中性</h2>
                                <span class="fr"><i class="icons neutral-icon"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid h-auto mt20" v-if="defaultWords != ''">
                    <div class="grid-header">
                        <h2 class="title">主题词</h2>
                    </div>
                    <div class="grid-body mt30">
                        <div class="echart-warp hidden h259">
                            <cloudChart id="wordCloud" :dataArray="defaultWords" cuozu="50px"></cloudChart>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden">
                <div class="detail-warp clearfix">
                    <div class="clearfix">
                        <h1 v-html="detail.newsTitle" class="hidden"></h1>
                    </div>
                    <p class="ziduan color-8a8a99 mt10">
                        <span>时间：{{detail.newsPosttime}}</span>
                        <span>来源：<i class="icons sm-icon" :class="$parent.icons[detail.platform]"></i>{{detail.mediaName}}</span>
                        <span v-if="detail.newsContentIpLocation!=''">IP属地：{{detail.newsContentIpLocation}}</span>
                        <a class="color-blue ml20" :href="detail.newsUrl" target="_blank" rel='noreferrer'>原文链接</a>
                    </p>
                    <div class="content mt30 vhtmltext" v-html="detail.newsContent" v-if="detail.platform != 'video'"></div>
                    <div class="content mt30" v-if="detail.newsVideoUrls && (detail.platform === 'video'||detail.platform === '视频')">
                        <video class="video" :src="detail.newsVideoUrls[0]" controls="controls" v-if="detail.newsVideoUrls.length > 0">
                            请升级您的浏览器
                        </video>
                        <img :src="detail.newsImgUrls[0]" class="db" v-if="detail.newsVideoUrls.length < 0" referrerPolicy="no-referrer"/>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
// import halfPieChart from '../../components/echart/halfPieChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
export default {
    components:{cloudChart},
    data() {
        return {
            // halfPieChartData:[],//分析词
            emotion:'',//情感属性
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            defaultWords:[],
            newsVideoUrls:'',//视频链接
            id:'',
            planId:'',
            detail:[]
        }
    },
    mounted() {
		this.$nextTick(()=> {
            this.getDetailInformation();
        })
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取信息
        getDetailInformation () {
            let that = this;
            let id = that.$route.query.id;//获取当前页面url的type
            let keywords = that.$route.query.keywords;//获取当前页面url的type
            that.id = id;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('monitor/search/detail',{newsId:id,keywords:keywords},r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.detail = r.data;
                    that.halfPieChartAjax();
                    that.wordEcharts();
                });           
            })
        },
		halfPieChartAjax(){
            let that = this;
            // let newData =  {
            //     total:1,
            //     data:{value:that.detail.newsEmotionScore, name:that.detail.newsEmotion}
            // };
            that.emotion = that.detail.newsEmotion;
        },
        // 主题词
        wordEcharts () {
            let that = this;
            this.defaultWords = that.detail.newsKeywords;
        },
        // // 收藏
        // collectFn (id) {
        //     let that = this;
        //     let newsList = that.newsList;
        //     let sc = that.detail.collectStatus;//获取收藏状态
        //     let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
        //     let data = {
        //         type:1,
        //         typeId:[id]
        //     };
        //     that.$parent.loadModal(true,'正在提交数据');
        //     that.$api.post(url, {data:data}, r => {
        //         that.$parent.returnCode(r,function(){
        //             that.$parent.showLoad = false;
        //             sc = sc === 0 ? 1 : 0;
        //             that.detail.collectStatus = sc;
        //             that.$utils.alertText('操作成功');
        //         });
                
        //     })
        // },  
        // // 预警
        // earlyWarning () {
        //     let that = this;
        //     let isSupportArtificialWarningSet = that.$parent.isSupportArtificialWarningSet;//检测预警功能
        //     if(isSupportArtificialWarningSet != 1){
        //         that.$parent.alertTips('对不起，你暂无使用预警功能的权限！');
        //         return;
        //     }
        //     let uuid = [that.id];
        //     let url = '';
        //     let type = that.detail.warningStatus;
        //     if(type === 0){//添加预警
        //         url = 'monitor/warning/artificial-create';
        //     }else if(type === 1){//取消预警
        //         url = 'monitor/warning/artificial-delete';
        //     }
        //     let datas = {
        //         sid:that.planId,
        //         newsId:uuid
        //     };
        //     that.$parent.loadModal(true,'正在提交数据');
        //     that.$api.post(url, {data:datas}, r => {
        //         that.$parent.returnCode(r,function(){
        //             that.$parent.showLoad = false;
        //             if(type === 0){//添加预警
        //                 that.detail.warningStatus = 1;
        //             }else if(type === 1){//取消预警
        //                 that.detail.warningStatus = 0;
        //             }
        //             that.$utils.alertText('操作成功');
        //         });
        //     })
        // }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/detail.vue